import { Typography } from 'antd'
import { AddressLine, GetDirectionsLink } from '@/src/components'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Physician } from '@/src/interfaces'

const { Text } = Typography

export const GeoLocationAddress = ({
  physician,
  isProfileCard,
}: {
  physician: Physician
  isProfileCard?: boolean
}) => {
  return (
    <>
      <div className='flex flex-row items-center  mt-0 md:mt-4 gap-2 overflow-hidden'>
        <div className='flex flex-col items-center p-2 rounded-full border border-gray-400'>
          <FontAwesomeIcon icon='location-dot' className='text-red-600' />
          <Text
            type='secondary'
            className='whitespace-nowrap custom-physician-bio-text ant-typography'
          >
            {Number(physician.geo_distance_miles).toFixed(1)} mi
          </Text>
        </div>
        <div className='flex flex-col'>
          {isProfileCard ? (
            <>
              <AddressLine
                physicianAddress={physician.address}
                physicianCity={physician.city}
                physicianState={physician.state}
                physicianZip={physician.zip}
              />
            </>
          ) : (
            <>
              <Text
                type='secondary'
                className='custom-physician-bio-text ant-typography'
              >
                <FontAwesomeIcon icon='location-dot' className='mr-2' />
                {physician.address}
              </Text>
              <GetDirectionsLink
                physician={physician}
                isProfileCard={isProfileCard}
              />
            </>
          )}
        </div>
      </div>
      {isProfileCard && (
        <div className='mt-2'>
          <GetDirectionsLink
            physician={physician}
            isProfileCard={isProfileCard}
          />
        </div>
      )}
    </>
  )
}
